import { TimeUnitKey } from '../../../types';
import getTimeUnitSorter from './get-time-unit-sorter';

const sortTimeUnits = (source: number[] | string[], timeUnitKey: TimeUnitKey) => {
    const sortFn = getTimeUnitSorter(timeUnitKey);
    return source.sort(sortFn);
};

export default sortTimeUnits;
